import RestModule from "../vue-ocom/store/RestModule.js";
import schema from "./schema/index.js";

import * as CONFIG from "../config.js";

var root_url = CONFIG.root_url;

const NotificationButtonModule = RestModule(
  root_url + "/notification/notification_button/",
  schema.NotificationButton
);
const NotificationStatusModule = RestModule(
  root_url + "/notification/notification_status/",
  schema.NotificationStatus
);
const NotificationModule = RestModule(
  root_url + "/notification/notification/",
  schema.Notification
);
const UserNotificationModule = RestModule(
  root_url + "/notification/user_notification/",
  schema.UserNotification
);
//Add more modules here if needed. These will automatically be included and available in main store.

export default {
  NotificationButtonModule,
  NotificationStatusModule,
  NotificationModule,
  UserNotificationModule,
  //Add more modules here
};
